import React, { memo, useState, useEffect } from 'react'
import { useResolveInitialUsers } from 'state/users'
import isEqual from 'react-fast-compare'
import { pick } from 'utilities/object'
import { Form } from './s'
import Field from 'components/form/field/people'

const PickUsersField = memo(({ filter, setFilter, resetFilterField, resetAt, name, field = null, picker = {}, salt }) => {
    const getValue = () => filter?.[name] ?? field?.defaultValue ?? []

    const [hasInteracted, setHasInteracted] = useState(false)

    const {
        items: users,
        setItems: setUsers,
        isFetching
    } = useResolveInitialUsers({
        queryOptions: {
            enabled: !!getValue().length
        },
        params: { ids: getValue() }
    })

    // Unset the users when value is unset from the outside
    useEffect(() => {
        (!getValue().length && !!users.length) && setUsers([])
    }, [getValue().length, users.length])

    return (
        <Form>
            <Field
                className="compact wide"
                salt={salt}
                label={false}
                name={name}
                field={{
                    ...field,
                    value: users
                }}
                picker={picker}
                enabled={!isFetching}
                onChange={({ [name]: users }) => {
                    if(!hasInteracted) {
                        return
                    }

                    setFilter({ [name]: users.map(({ id }) => id) })
                    setUsers(users)
                }}
                onToggle={() => setHasInteracted(true)}
                onUnset={() => {
                    setFilter({ [name]: [] })
                    setUsers([])
                    resetFilterField()
                }}
                key={`${salt}:${name}:${users.map(({ id }) => id).join('+') ?? 'empty'}:${resetAt}:${isFetching}`} />
        </Form>
    )
}, (previous, next) => isEqual(
    pick(previous, ...props),
    pick(next, ...props)
))

const props = ['filter', 'resetAt', 'name', 'field', 'entity', 'salt']

export default PickUsersField